import { DialogPanel } from '@/features/dialogs/common/components/DialogPanel'
import { DialogPanelTitle } from '@/features/dialogs/common/components/DialogPanelTitle'
import { HealthFactorChange } from '@/features/dialogs/common/components/transaction-overview/HealthFactorChange'
import { PositionOverview } from '../logic/types'
import { TokenValueChange } from '@/features/dialogs/common/components/transaction-overview/TokenValueChange'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { TokenWithValue } from '@/domain/common/types'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { NumberValueChange } from '@/features/dialogs/common/components/transaction-overview/NumberValueChange'
export interface RepayOverviewPanelProps {
  repayAsset: TokenWithValue
  walletOverview: MyWalletProps
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  updatedLiquidationPrice: NormalizedUnitNumber
}

export function RepayOverviewPanel({
  repayAsset,
  walletOverview,
  currentPositionOverview,
  updatedPositionOverview,
  updatedLiquidationPrice,
}: RepayOverviewPanelProps) {
  const remainingDebt = walletOverview.repay?.available
    ? NormalizedUnitNumber(Math.max(0, walletOverview.repay.available.toNumber() - repayAsset.value.toNumber()))
    : NormalizedUnitNumber(0)

  return (
    <DialogPanel>
      <DialogPanelTitle>Transaction overview</DialogPanelTitle>
      <TokenValueChange
        token={repayAsset.token}
        currentValue={walletOverview.repay!.available}
        updatedValue={remainingDebt}
        label="Debt"
      />
      <NumberValueChange
        currentValue={walletOverview.liquidationDetails.liquidationPrice}
        updatedValue={updatedLiquidationPrice}
        label="Liquidation price"
      />
      <HealthFactorChange
        currentHealthFactor={currentPositionOverview.healthFactor}
        updatedHealthFactor={updatedPositionOverview?.healthFactor}
      />
    </DialogPanel>
  )
}
